import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Route, Routes, Link } from "react-router-dom";
import Sidebar from "./components/Sidebar2.js";
import Charts2d from "./vis 1/3dStacked.js";
import Charts3d from "./vis 1/2dStackedChart";
import "../src/App.css";
import Percentage3D from "./vis 1/Percentage3D";
import "../src/App.css";
import ColumnChart from "./vis 2/DivergingBar";
import ColumnChart2 from "./vis 2/DivergingBar2";
import Heatmap from "./vis 2/Heat-map.js";
import Percentage2D from "./vis 1/Percentage2D";
import Percentage2DColor from "./vis 1/Percentage2DColor";
import Percentage3DColor from "./vis 1/Percentage3DColor";
import ColumnChart3 from "./vis 2/DivergingBar3";
import Drilldown1 from "./vis 3/Drilldown1"; // Drilldown V1
import Drilldown2 from "./vis 3/Drilldown2.1.js"; // Drilldown V2.1
import Drilldown3 from "./vis 3/Drilldown2.2.js";
import Drilldown4 from "./vis 3/Drilldown3.js"; // Drilldown V3
import Drilldown5 from "./vis 3/Drilldown4.js"; // Drilldown V4
import Drilldown6 from "./vis 3/Drilldown5.1.js"; // Drilldown V4
import Drilldown7 from "./vis 3/Drilldown5.3.js";
import Drilldown8 from "./vis 3/Drilldown5.5.js";
import Drilldown9 from "./vis 3/Drilldown5.4.js";
import Drilldown10 from "./vis 3/Drilldown5.2.js";
import Widgets1 from "./Vis 4/Widgets1.js";
import Widgets2 from "./Vis 4/Widgets2.js";
import Widgets3 from "./Vis 4/Widgets3.js";
import Widgets4 from "./Vis 4/Widgets4.js";
import Widgets5 from "./Vis 4/Widgets5.js";
import Widgets6 from "./Vis 4/Widgets6.js";
import Widgets7 from "./Vis 4/Widgets7.js";
import Widgets8 from "./Vis 4/Widgets8.js";
import Widgets9 from "./Vis 4/Widgets9.js";
import Widgets10 from "./Vis 4/Widgets10.js";
import Widgets11 from "./Vis 4/Widgets11.js";
import Widgets12 from "./Vis 4/Widgets12.js";
import Widgets13 from "./Vis 4/Widgets13.js";
import CRENetwork from "./vis 2/CREvis.js";
import CRENetwork2 from "./vis 2/CREvis2.js";
import Drilldown11 from "./vis 3/Drilldown2.1(NewColor).js"; // Drilldown V5.1
import Boxplot from "./vis 5/boxplot.js";
import Scatterplot from "./vis 5/scatterplot.js";
import Scatterplot2 from "./vis 5/scatterplot2.js";
import Scatterplot3 from "./vis 5/scatterplot3.js";
import Scatterplot4 from "./vis 5/scatterplot4.js";
import Scatterplot5 from "./vis 5/scatterplot5.js";
import Scatterplot6 from "./vis 5/scatterplot6.js";
import Boxplot2 from "./vis 5//boxplot2.js";
import Histogram from "./vis 5/histogram.js"
import Histogram2 from "./vis 5/histogram2.js"
import UpSetPlot from "./vis 5/upSet1.js"

// Drilldown V5.2

const Dashboard = () => {
  const [openVis1, setOpenVis1] = useState(false);
  const [openVis2, setOpenVis2] = useState(false);
  const [openVis3, setOpenVis3] = useState(false);
  const [openVis4, setOpenVis4] = useState(false);

  return (
    <BrowserRouter>
      <div
        className="container-fluid"
        style={{ fontFamily: "'Roboto Flex', serif" }}
      >
        <div className="row">
          <Sidebar></Sidebar>

          <main className="col-md-10 p-0 ">
            <div
              className="d-flex flex-md-nowrap flex-wrap align-items-center justify-content-between mb-0 pb-2 pt-2"
              style={{ width: "99%" }}
            >
              <h1
                className="h2 px-4 py-2"
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "900",
                  color: "#3E3E8C",
                  marginBottom: "0px !important",
                }}
              >
                Dashboard
              </h1>
              <div className="dropdown">
                <button
                  className="btn btn-light dropdown-toggle"
                  type="button"
                  style={{
                    border: "none",
                    background: "none",
                    fontWeight: "700",
                    color: "#596170",
                  }}
                >
                  John Doe
                </button>
              </div>
            </div>
            <Routes>
              <Route path="/" element={<Drilldown1 />} />
              <Route path="/stacked-bar" element={<Charts3d />} />
              <Route path="/stacked-bar-color" element={<Charts2d />} />
              <Route
                path="/3Dpercentage-color"
                element={<Percentage3DColor />}
              />
              <Route path="/3Dpercentage" element={<Percentage3D />} />
              <Route path="/2Dpercentage" element={<Percentage2D />} />
              <Route
                path="/2Dpercentage-color"
                element={<Percentage2DColor />}
              />
              <Route path="/Diverging-Bar1" element={<ColumnChart />} />
              <Route path="/Diverging-Bar2" element={<ColumnChart2 />} />
              <Route path="/Diverging-Bar3" element={<ColumnChart3 />} />
              <Route path="/Heat-Map" element={<Heatmap />} />
              <Route path="/Drilldown1" element={<Drilldown1 />} />
              <Route path="/Drilldown2.1" element={<Drilldown2 />} />
              <Route path="/Drilldown2.1newColor" element={<Drilldown11 />} />
              <Route path="/Drilldown2.2" element={<Drilldown3 />} />
              <Route path="/Drilldown3" element={<Drilldown4 />} />
              <Route path="/Drilldown4" element={<Drilldown5 />} />
              <Route path="/Drilldown5.1" element={<Drilldown6 />} />
              <Route path="/Drilldown5.3" element={<Drilldown7 />} />
              <Route path="/Drilldown5.5" element={<Drilldown8 />} />
              <Route path="/Drilldown5.4" element={<Drilldown9 />} />
              <Route path="/Drilldown5.2" element={<Drilldown10 />} />
              <Route path="/CRENetwrok" element={<CRENetwork />} />
              <Route path="/CRENetwrok2" element={<CRENetwork2 />} />
              <Route path="/Widgets1" element={<Widgets1 />} />
              <Route path="/Widgets2" element={<Widgets2 />} />
              <Route path="/Widgets3" element={<Widgets3 />} />
              <Route path="/Widgets4" element={<Widgets4 />} />
              <Route path="/Widgets5" element={<Widgets5 />} />
              <Route path="/Widgets6" element={<Widgets6 />} />
              <Route path="/Widgets7" element={<Widgets7 />} />
              <Route path="/Widgets8.1" element={<Widgets8 />} />
              <Route path="/Widgets8.3" element={<Widgets9 />} />
              <Route path="/Widgets8.2" element={<Widgets10 />} />
              <Route path="/Widgets9" element={<Widgets11 />} />
              <Route path="/Widgets10" element={<Widgets12 />} />
              <Route path="/Widgets11" element={<Widgets13 />} />
              <Route path="/Boxplot" element={<Boxplot />} />
              <Route path="/Boxplot2" element={<Boxplot2 />} />
              <Route path="/Scatterplot" element={<Scatterplot />} />
              <Route path="/Scatterplot2" element={<Scatterplot2 />} />
              <Route path="/Scatterplot3" element={<Scatterplot3 />} />
              <Route path="/Scatterplot4" element={<Scatterplot4 />} />
              <Route path="/Scatterplot5" element={<Scatterplot5 />} />
              <Route path="/Scatterplot6" element={<Scatterplot6 />} />
              <Route path="/Histogram" element={<Histogram />} />
              <Route path="/Histogram2" element={<Histogram2 />} />
              <Route path="/UpsetPlot1" element={<UpSetPlot />} />
            </Routes>
          </main>
        </div>
      </div>
    </BrowserRouter>
  );
};

export default Dashboard;
